export default __webpack_public_path__ + "static/media/labrequicon.c24fa4bb.svg";